import { z } from "zod";

export const LegalEntityShort = z
  .object({
    id: z.number(),
    backgroundImageSystemId: z.string().nullable(),
    backgroundImagePublicUrl: z.string().nullable(),
    logoSystemId: z.string().nullable(),
    logoPublicUrl: z.string().nullable(),
    name: z.string(),
    publicProfileId: z.number().nullable(),
    publicProfileSlug: z.string().nullable(),
    publicProfileName: z.string().nullable(),
    aboutUs: z.string().nullish(),
    aboutUsFlavorText: z.string().nullish(),
    vatNumber: z.string().nullish(),
    country: z.string().nullish(),
  })
  .passthrough();

export type LegalEntityShort = z.infer<typeof LegalEntityShort>;
